export function hrmsProfile(row) {
  const employee = row.employee || row;
  const assignment = employee.assignments?.find(a => a.isPrimary !== false) || employee.assignments?.[0] || {};
  const text = value => typeof value === 'object' ? value?.name || '' : String(value || '');
  return {
    branch: text(employee.branch || assignment.branch),
    department: text(employee.department || assignment.department),
    designation: text(employee.designation || assignment.designation),
    employmentType: employee.employmentType || assignment.employmentType || '',
    employeeStatus: employee.employeeStatus || (row.employee ? employee.status : ['Active','Draft','Inactive','Exited','ACTIVE','DRAFT','INACTIVE','EXITED'].includes(employee.status) ? employee.status : ''),
    gender: employee.gender || '', salaryType: employee.salaryType || employee.compensation?.salaryType || '',
    paymentMode: employee.paymentMode || employee.compensation?.paymentMode || '', shiftType: employee.shiftType || employee.workSchedule?.shiftType || '',
    accountStatus: employee.accountStatus || employee.user?.status || (employee.user ? employee.user.isActive ? 'ACTIVE' : 'INACTIVE' : ''),
    roles: employee.roles || (employee.user?.roles || []).map(value => value.role?.name).filter(Boolean),
    joiningDate: (employee.joiningDate || '').slice(0,10),
  };
}

export function matchesHrmsFilters(row, filters) {
  const profile = hrmsProfile(row);
  return Object.entries(filters).every(([key,value]) => {
    if (!value) return true;
    if (key === 'recordStatus') return row.status === value;
    if (key === 'joinedFrom') return Boolean(profile.joiningDate && profile.joiningDate >= value);
    if (key === 'joinedTo') return Boolean(profile.joiningDate && profile.joiningDate <= value);
    return Array.isArray(profile[key]) ? profile[key].includes(value) : profile[key] === value;
  });
}
